import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, VehiclesActionCreator } from 'src/store/states';
import VehLayout from '../VehLayout';

const mapStateToProps = (state: IStoreState) => ({
    viewMode: state.Framework.viewMode,
    appointment: state.Appointment,
    custMode: state.Framework.custMode,
    specInfo: state.Specs.specs,
    recallData: state.AdditionalServices.recallData,
    MCData: state.AdditionalServices.maintContractData,
    theme: state.Framework.theme,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    locale: state.Framework.locale,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    prevRecomSvcs: state.AdditionalServices.allServices.recom,
    additionalServicesBuilt: state.AdditionalServices.allServices.built,
    roHistory: state.ROHistory.allRoHistory.roHistory,
    roHistoryBuilt: state.ROHistory.allRoHistory.built,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    countryCode: state.Framework.dealerCountry,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    sessionId: state.Framework.sessionId,
});

const mapDispatchToProps = {
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    getVehicles: VehiclesActionCreator.GetVehicles,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    addLogEntry: FrameworkActionCreator.addLogEntry,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VehLayout);